import { render, staticRenderFns } from "./PendingBlocks.vue?vue&type=template&id=62f7e1e1&"
import script from "./PendingBlocks.vue?vue&type=script&lang=js&"
export * from "./PendingBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports